export const pageId = 'atlassianAccountSignupScreen' as const;
